import { CustomerStatus } from "../../constants/data"
import CircleIcon from "@mui/icons-material/Circle"
import {
  MarkedNoChip,
  MarkedPendingChip,
  MarkedYesChip,
} from "../Transactions/styles"

export const CustomerStatusChip: React.FC<any> = ({ row }) => {
  const customerStatus = row.status
  switch (customerStatus) {
    case CustomerStatus.ACTIVE:
      return (
        <MarkedYesChip
          label="Active"
          size="small"
          variant="outlined"
          icon={<CircleIcon fontSize="inherit" />}
        />
      )
    case CustomerStatus.INACTIVE:
      return (
        <MarkedPendingChip
          label="Inactive"
          size="small"
          variant="outlined"
          icon={<CircleIcon fontSize="inherit" />}
        />
      )
    default:
      return (
        <MarkedNoChip
          label="Deleted"
          size="small"
          variant="outlined"
          icon={<CircleIcon fontSize="inherit" />}
        />
      )
  }
}
